import {
    InertiaApp
} from '@inertiajs/inertia-vue'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
import Vue from 'vue'

Vue.mixin({
    methods: {
        route: (...args) => window.route(...args).url()
    }
})
Vue.use(InertiaApp)
Vue.use(VueMeta)
Vue.use(PortalVue)

let app = document.getElementById('app')

new Vue({
    metaInfo: {
        title: 'Loading...',
        titleTemplate: '%s | Kiln Management'
    },
    render: h => h(InertiaApp, {
        props: {
            initialPage: JSON.parse(app.dataset.page),
            resolveComponent: name => import(`@/Pages/${name}`).then(module => module.default),
        },
    }),
}).$mount(app)
